import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Loader} from 'semantic-ui-react';
import {ContentDispatch} from 'framework';
import REST from 'go/requests/rest';

export const ApplicationsByStateList = (props) => {
  const {contents, saveEntitySessionData, contextPathToSave} = props;
  const [done, setDone] = useState(false);
  const keys = Object.keys(_.get(props.dependencies, '0'));
  const args = [];
  let orgIds = [];
  let foIds = [];
  let fundingOpportunityData = {};
  let payloadList = [];
  let applications;
  _.each(keys, (key) => args.push(props[key]));
  useEffect(() => {
    const {
      entityType,
      subOrgId,
      primaryAct = '',
      subAct = '',
      budgetAmount,
      locationCount,
    } = props;
    let restCall;
    let extraProps = {};
    if (entityType) {
      restCall = REST.search.getEntitiesByTypeFoAndSubOrgId;
      extraProps = {
        entityType: entityType,
        subOrgId: subOrgId,
        primaryAct: primaryAct,
        subAct: subAct,
        budgetAmount: budgetAmount,
      };
    } else {
      restCall = REST.search.getApplicationByFOAndOrgState;
    }
    restCall(
      props.token,
      props.physicalState,
      props.foId,
      props.orgId,
      props.sortOrder,
      props.limit,
      extraProps
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          saveEntitySessionData(contextPathToSave, payloadList);
          setDone(true);
          return Promise.reject();
        }
      })
      .then((resJson) => {
        applications = resJson;
        if (_.isEmpty(applications.items)) {
          saveEntitySessionData(contextPathToSave, payloadList);
          setDone(true);
          return Promise.reject();
        }
        _.forEach(applications, (itemList) => {
          _.forEach(itemList, (item) => {
            if (entityType) {
              orgIds.push(_.get(item, 'subOrgId'));
            } else {
              orgIds.push(_.get(item, 'organizationId'));
              orgIds.push(_.get(item, 'subOrgId'));
            }
            foIds.push(_.get(item, 'fundingOpportunityId'));
          });
        });
        Promise.all(
          _.map(_.chain(foIds).uniq().compact().value(), (foId) => {
            return REST.fundingOpportunity.getFundingOpportunity(props.token, foId);
          })
        )
          .then((res) =>
            Promise.all(
              _.map(res, (fo) => {
                return fo.json();
              })
            )
          )
          .then((foData) => {
            _.each(foData, (fo) => {
              _.set(
                fundingOpportunityData,
                fo.fundingOpportunityId,
                fo.fundingOpportunityName
              );
            });
          })
          .then(() => {
            REST.organization
              .getOrganizationsListById(props.token, _.uniq(orgIds))
              .then(REST.handler.handleResponse)
              .then((result) => {
                _.forEach(applications, (application) => {
                  _.forEach(application, (item) => {
                    _.forEach(result, (orgInfo) => {
                      payloadList.push({
                        grantId: _.get(item, 'grantId'),
                        subGrantId: _.get(item, 'subGrantId'),
                        federalShareAmount: _.get(item.payload, 'budget.share.fedShare'),
                        budgetAmount: _.get(
                          item.payload,
                          'budget.budgetSummary.totalCharges'
                        ),
                        organizationName: _.get(orgInfo, 'displayName'),
                        mailingAddressState: _.get(orgInfo.mailingAddress, 'state'),
                        physicalAddressState: _.get(orgInfo.physicalAddress, 'state'),
                        ueieft: _.get(orgInfo, 'uei')
                          ? _.get(orgInfo, 'uei') +
                            (!_.isEmpty(_.trim(_.get(orgInfo, 'eft')))
                              ? '-' + _.trim(_.get(orgInfo, 'eft'))
                              : '')
                          : '',
                        duns: _.get(orgInfo, 'duns'),
                        locNumber: _.size(
                          _.get(
                            item,
                            'payload.location.projectSiteInventory.projectLocations'
                          )
                        ),
                        subApplicationTitle: _.get(item, 'payload.applicationTitle'),
                        primaryAct: _.get(
                          item,
                          'payload.scopeOfWork.primaryActivityType'
                        ),
                        subactivity: _.get(
                          item,
                          'payload.scopeOfWork.primarySubActivityType'
                        ),
                        totalAmount: _.get(item, 'payload.budget.totalAmount'),
                        fundingOpportunityName: _.get(
                          fundingOpportunityData,
                          item.fundingOpportunityId
                        ),
                      });
                    });
                  });
                });

                if (entityType) {
                  payloadList = _.filter(payloadList, (i) => {
                    return (i.locNumber = locationCount);
                  });
                }

                let otherApplicationobject = {
                  otherApplications: _.sortBy(payloadList, [
                    'organizationName',
                    'grantId',
                  ]),
                };
                saveEntitySessionData(contextPathToSave, otherApplicationobject);
                setDone(true);
              });
          });
      });
  }, []);
  return (
    <>
      {!done && <Loader active inline="centered" />}
      {done &&
        contents.map((entry, index) => {
          return <ContentDispatch config={entry} key={entry.title} />;
        })}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export default connect(mapStateToProps, null)(connectDynamic(ApplicationsByStateList));
